// sales reports routes
const SalesSummary  = () => import("./index.vue");
const SaleInvoicesReport  = () => import("./sale-invoices.vue");
const SoldProductsReport = () => import("./sold-products.vue");
const SoldProductsSummaryReport = () => import("./sold-products-summary.vue");
const GroupedByDateSalesReport = () => import("./grouped-sales.vue");
const BranchSalesReport = () => import("./branch-sales.vue");
const OutsourcedSalesReport = () => import("./outsourced-sales.vue");
const SalesReturnReport = () => import("./sale-returns.vue");
const ProfitMarginReport = () => import("./profit-margin.vue");
const CombinedProfitReport = () => import("./combined-profit.vue");
const CombinedSalesByBrand = () => import("./combined-sales-by-brand.vue");
const CombinedSoldProductsReport = () => import("./combined-sold-products.vue");
const EmployeesPerformanceReport = () => import("./employees-performance-report.vue");
const BrandsPerformanceReport = () => import("./brands-performance-report.vue");

export default [
  {
    path: "/sales-summary",
    component: SalesSummary,
  },
  {
    path: "/sales-invoices-report",
    component: SaleInvoicesReport,
  },
  {
    path: "/sold-products-report",
    component: SoldProductsReport,
  },
   {
    path: "/combined-sold-products-report",
    component: CombinedSoldProductsReport,
  },
   {
    path: "/sold-products-summary-report",
    component: SoldProductsSummaryReport,
  },
  {
    path: "/grouped-by-date-sales-report",
    component: GroupedByDateSalesReport,
  },
  {
    path: "/branch-sales-report",
    component: BranchSalesReport,
  },
  {
    path: "/outsourced-sales-report",
    component: OutsourcedSalesReport,
  },
  {
    path: "/sales-return-report",
    component: SalesReturnReport,
  },
  {
    path: "/profit-margin-report",
    component: ProfitMarginReport,
  },
  {
    path: "/combined-profit-report",
    component: CombinedProfitReport,
  },
  {
    path: "/combined-sales-by-brand",
    component: CombinedSalesByBrand,
  },
  {
    path: "/employees-performance-report",
    component: EmployeesPerformanceReport,
  },
  {
    path: "/brands-performance-report",
    component: BrandsPerformanceReport,
  },
];
